import uuid from 'uuid/v1'
import md5 from 'md5'
import Cookies from 'js-cookie'

export function getParams(data) {
    var params={
        c:'m',
        cv: Cookies.get("cv") || '4.8.0',
        guid:uuid()
    }
    if(data){
        params.body=JSON.stringify(data)
    }
    params.sign=md5(md5(params.body||'') + "xtlzgb" + params.guid)
    return params
}
